import { gql } from '@apollo/client'

export default gql(`
mutation deleteFilter($id: ID!, $project: String){
    deleteFilter(input:{
      id: $id
    }
    project: $project
    ){
        id
    }
  }
`)
